import React, {useMemo} from "react";

import {Checkbox, CheckboxProps} from "antd";
import {CheckboxGroupProps} from "antd/es/checkbox";
import {useDataAll} from "../../../api/useDataAll";
import {queries} from "../../../api/queries";
import {useTranslation} from "react-i18next";
import {SellerListType} from "../../../api/apiTypes";
import Lottie from "lottie-react";
import spinner from "../../../assets/lotties/spinner.json";
import {removeExistingParamsArrayValue} from "../../../common/fns";
import {useSearchParams} from "react-router-dom";

interface Props extends CheckboxGroupProps {
}

const ReturnSellerFilter = ({value}: Props) => {
  const {t} = useTranslation(["shipping"]);
  const [_, setSearchParams] = useSearchParams();
  const {listData, isLoading} = useDataAll<SellerListType>(queries.shop.list, {
    allow_return: '1', ordering: "name"
  });
  const allUuid = useMemo(() => {
    if (listData) {
      return listData.map((batch) => batch.uuid);
    }
    return [];
  }, [listData]);
  const checkAll = value && listData?.length > 0 && listData?.length === value.length;
  
  const handleChangeChecked = (checkedValues: any[]) => {
    console.log("checked = ", checkedValues);
    setSearchParams((prev) => ({
      ...removeExistingParamsArrayValue(prev, "return_order__shop__uuid__in", checkedValues),
      return_order__shop__uuid__in: checkedValues
    }));
  };
  
  const handleCheckAll: CheckboxProps['onChange'] = (e) => {
    if (e.target.checked) {
      setSearchParams((prev) => ({
        ...removeExistingParamsArrayValue(prev, "return_order__shop__uuid__in", allUuid),
        return_order__shop__uuid__in: allUuid
      }));
    }
    else {
      setSearchParams((prev) => ({
        ...removeExistingParamsArrayValue(prev, "return_order__shop__uuid__in", value), return_order__shop__uuid__in: []
      }));
    }
  };
  
  return (<div className={"column"}>
    <div className={"title"}>
      <span>{t("return shop")}</span>
      <Checkbox className={"checkAll"} onChange={handleCheckAll}
                checked={checkAll}>
        전체
      </Checkbox>
    </div>
    <Checkbox.Group
      className={"wrapper-rd-wh-sm check"}
      value={value}
      onChange={handleChangeChecked}
    >
      {listData && listData.length ? listData.map((s, idx) => (<Checkbox
        key={"check" + idx}
        className={"item"}
        data-cy="homeManageCheckbox"
        value={s.uuid}
      >
        {s.name}
      </Checkbox>)) : (isLoading ? <Lottie autoplay animationData={spinner} loop style={{height: 25}} /> : <span
        className={"nodata"}>데이터가 없습니다</span>)}
    </Checkbox.Group>
  </div>);
};

export default ReturnSellerFilter;
